import React from "react";
import LoginInner from "../components/LoginInner";

const LoginPage = () => {
  return (
    <>
      {/* LoginInner */}
      <LoginInner />
    </>
  );
};

export default LoginPage;
